module.exports = __webpack_public_path__ + "static/img/logos_azteca_gris.129c7a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logos_azteca_gris.png
// module id = 124
// module chunks = 0